import '../../../../packages/neb-lit-components/src/components/tables/neb-table';
import '../../../../packages/neb-lit-components/src/components/neb-button';

import { LitElement, html, css } from 'lit';

import { baseStyles } from '../../../../packages/neb-styles/neb-styles';
import {
  CSS_COLOR_HIGHLIGHT,
  CSS_FONT_WEIGHT_BOLD,
} from '../../../../packages/neb-styles/neb-variables';
import { MODE } from '../../../../packages/neb-utils/table';

export const ELEMENTS = {
  title: { id: 'title' },
  table: { id: 'table' },
};

const emptyTableMessage =
  'No providers are available for the selected appointment type. Click Back on your browser to choose a different option.';

class NebPageBookingProviders extends LitElement {
  static get properties() {
    return {
      layout: {
        type: String,
        reflect: true,
      },
      providers: Array,
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        .table {
          padding-left: 5px;
        }

        .title {
          color: ${CSS_COLOR_HIGHLIGHT};
          font-size: 16px;
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
          padding: 30px 25px 0;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.__config = [
      {
        key: 'firstName',
        label: '',
        flex: css`1 0 0`,
        mobile: true,
        formatter: (firstName, row) => `${row.lastName}, ${firstName}`,
      },
      {
        key: 'id',
        label: '',
        flex: css`0 0 0`,
        mobile: false,
        formatter: id => html`
          <neb-button
            label="Select"
            .name="${id}"
            .onClick="${this.__handlers.selectProvider}"
          ></neb-button>
        `,
      },
    ];

    this.providers = [];

    this.onSelectProvider = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      selectProvider: ({ name: id }) => {
        this.onSelectProvider(id);
      },

      selectRow: (_, { id }) => {
        this.onSelectProvider(id);
      },
    };
  }

  render() {
    return html`
      <div id="${ELEMENTS.title.id}" class="title">Select a Provider</div>
      <neb-table
        id="${ELEMENTS.table.id}"
        class="table"
        .config="${this.__config}"
        .layout="${this.layout}"
        .mode="${this.layout === 'small' ? MODE.DETAIL : MODE.NONE}"
        .model="${this.providers}"
        .emptyMessage="${emptyTableMessage}"
        .onSelectRow="${this.__handlers.selectRow}"
      ></neb-table>
    `;
  }
}

customElements.define('neb-page-booking-providers', NebPageBookingProviders);
